import { useHistory, useLocation } from "react-router-dom";

export function useGoToFaq() {
    const history = useHistory();
    const location = useLocation();

    const goToFaq = (anchor?: string) => {
        const isSiteCredentials = location.pathname.includes('/site-credentials');
        const basePath = isSiteCredentials
            ? '/site-credentials/faq'
            : '/continente-credentials/faq';

        const isValidAnchor = anchor && typeof anchor === 'string' && anchor.trim().length > 0;
        const path = isValidAnchor ? `${basePath}#${anchor}` : basePath;

        history.push(path);
    };

    return goToFaq;
}
